/**
 * A picture's corner radius in composition pixels (#77). `radius` is what
 * the inspector writes, clamped to half the shorter side, where the corners
 * meet (a circle on a square box, a pill otherwise). A picture saved before
 * `radius` existed still has its `shape`, read as before: square corners,
 * 20% of the shorter side, or round.
 */
export function pictureRadius(
  props: { shape: 'rect' | 'rounded' | 'circle'; radius?: number },
  width: number,
  height: number,
): number {
  const half = Math.min(width, height) / 2
  if (props.radius != null) return Math.min(Math.max(0, props.radius), half)
  if (props.shape === 'circle') return half
  if (props.shape === 'rounded')
    return Math.round(Math.min(width, height) * 0.2)
  return 0
}
